module.exports = __webpack_public_path__ + "img/ExportAnalysisResult.b0011a50.svg";